export default __webpack_public_path__ + "11fe551c5bba11f0d72643b681454c40.ogg";